var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
var runtime = (function (exports) {
  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1;
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);
    generator._invoke = makeInvokeMethod(innerFn, self, context);
    return generator;
  }
  exports.wrap = wrap;
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }
  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };
  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    IteratorPrototype = NativeIteratorPrototype;
  }
  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }
  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };
  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };
  exports.awrap = function(arg) {
    return { __await: arg };
  };
  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }
        return Promise.resolve(value).then(function(unwrapped) {
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          return invoke("throw", error, resolve, reject);
        });
      }
    }
    var previousPromise;
    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }
      return previousPromise =
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }
    this._invoke = enqueue;
  }
  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;
  exports.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );
    return exports.isGeneratorFunction(outerFn)
      ? iter
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };
  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;
    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }
      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }
        return doneResult();
      }
      context.method = method;
      context.arg = arg;
      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if (context.method === "next") {
          context.sent = context._sent = context.arg;
        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }
          context.dispatchException(context.arg);
        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }
        state = GenStateExecuting;
        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;
          if (record.arg === ContinueSentinel) {
            continue;
          }
          return {
            value: record.arg,
            done: context.done
          };
        } else if (record.type === "throw") {
          state = GenStateCompleted;
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      context.delegate = null;
      if (context.method === "throw") {
        if (delegate.iterator["return"]) {
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);
          if (context.method === "throw") {
            return ContinueSentinel;
          }
        }
        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }
      return ContinueSentinel;
    }
    var record = tryCatch(method, delegate.iterator, context.arg);
    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }
    var info = record.arg;
    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }
    if (info.done) {
      context[delegate.resultName] = info.value;
      context.next = delegate.nextLoc;
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }
    } else {
      return info;
    }
    context.delegate = null;
    return ContinueSentinel;
  }
  defineIteratorMethods(Gp);
  Gp[toStringTagSymbol] = "Generator";
  Gp[iteratorSymbol] = function() {
    return this;
  };
  Gp.toString = function() {
    return "[object Generator]";
  };
  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };
    if (1 in locs) {
      entry.catchLoc = locs[1];
    }
    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }
    this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }
  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }
      next.done = true;
      return next;
    };
  };
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }
      if (typeof iterable.next === "function") {
        return iterable;
      }
      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }
          next.value = undefined$1;
          next.done = true;
          return next;
        };
        return next.next = next;
      }
    }
    return { next: doneResult };
  }
  exports.values = values;
  function doneResult() {
    return { value: undefined$1, done: true };
  }
  Context.prototype = {
    constructor: Context,
    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;
      this.method = "next";
      this.arg = undefined$1;
      this.tryEntries.forEach(resetTryEntry);
      if (!skipTempReset) {
        for (var name in this) {
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },
    stop: function() {
      this.done = true;
      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }
      return this.rval;
    },
    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }
      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;
        if (caught) {
          context.method = "next";
          context.arg = undefined$1;
        }
        return !! caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;
        if (entry.tryLoc === "root") {
          return handle("end");
        }
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }
          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },
    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        finallyEntry = null;
      }
      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;
      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }
      return this.complete(record);
    },
    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }
      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }
      return ContinueSentinel;
    },
    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },
    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };
      if (this.method === "next") {
        this.arg = undefined$1;
      }
      return ContinueSentinel;
    }
  };
  return exports;
}(
   module.exports 
));
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  Function("r", "regeneratorRuntime = r")(runtime);
}
});

var regenerator = runtime_1;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
var asyncToGenerator = _asyncToGenerator;

var detector = createCommonjsModule(function (module, exports) {
(function (global, factory) {
   module.exports = factory() ;
}(commonjsGlobal, function () {  var detector = {
    iqiyi: function iqiyi() {
      return !!navigator.userAgent.match(/iqiyi\s*IqiyiVersion\/([\d.]+)/i);
    },
    zhishi: function zhishi() {
      return !!navigator.userAgent.match(/knowledge\s*KnowledgeVersion\/([\d.]+)/i);
    },
    chrome: function chrome() {
      return !!navigator.userAgent.match(/Chrome\/([\d.]+)/) || !!navigator.userAgent.match(/CriOS\/([\d.]+)/);
    },
    android: function android() {
      return !!navigator.userAgent.match(/(Android);?[\s/]+([\d.]+)?/);
    },
    iOS: function iOS() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    },
    iOSEgt9: function iOSEgt9() {
      return this.iOS() && /OS (\d+)/i.exec(navigator.userAgent)[1] >= 9;
    },
    iPad: function iPad() {
      return /iPad/.test(navigator.userAgent) && !window.MSStream;
    },
    iPhoneX: function iPhoneX() {
      if (typeof window !== 'undefined') {
        return /iphone/gi.test(navigator.userAgent) && window.screen.height >= 812;
      }
      return false;
    },
    vivo: function vivo() {
      return !!navigator.userAgent.match(/vivo (\w+) /i);
    },
    qq: function qq() {
      return !!navigator.userAgent.match(/(QQBrowser)\/([\d.]+)/);
    },
    uc: function uc() {
      return !!navigator.userAgent.match(/UCBrowser/i);
    },
    baidu: function baidu() {
      return !!navigator.userAgent.match(/baidu/i);
    },
    wechat: function wechat() {
      return /MicroMessenger/.test(navigator.userAgent);
    }
  };
  return detector;
}));
});

var iqiyi_1 = createCommonjsModule(function (module, exports) {
(function (global, factory) {
   module.exports = factory() ;
}(commonjsGlobal, function () {  var iqiyi$1 = {
    getVersion: function getVersion() {
      var zhishi = navigator.userAgent.match(/knowledge\s*KnowledgeVersion\/([\d.]+)/i);
      var iqiyi = navigator.userAgent.match(/iqiyi\s*IqiyiVersion\/([\d.]+)/i);
      var version = '';
      if (zhishi) {
        version = zhishi[1];
      } else if (iqiyi) {
        version = iqiyi[1];
      }
      if (!version) {
        return null;
      }
      var tmp = version.split('.');
      var array = tmp.map(function (item) {
        if (Number(item) < 10) {
          return "0".concat(item);
        }
        return item;
      });
      return Number(array.join(''));
    },
    ready: function ready() {
      return new Promise(function (resolve, reject) {
        if (typeof iqiyi === 'undefined') {
          reject(new Error("ready error: iqiyi not found, please detect iqiyi sdk has been installed!"));
          return;
        }
        iqiyi.ready(function (result) {
          if (!result) {
            reject(new Error('ready error: iqiyi.ready'));
            return;
          }
          resolve();
        });
      });
    },
    init: function init() {
      return this.ready().then(function () {
        return new Promise(function (resolve, reject) {
          iqiyi.init(function (result) {
            if (result.result === 0) {
              reject(new Error('init error: iqiyi.init'));
              return;
            }
            var data = result.data;
            if (data.P00001 === '0') {
              data.P00001 = '';
            }
            resolve(data);
          });
        });
      });
    }
  };
  return iqiyi$1;
}));
});

var cookie = createCommonjsModule(function (module, exports) {
(function (global, factory) {
   module.exports = factory() ;
}(commonjsGlobal, function () {  var cookie = {
    get: function get(name, cookies) {
      var items = cookies && cookies.split(';');
      if (!items || items.length === 0) {
        return '';
      }
      for (var i = 0; i < items.length; i = i + 1) {
        var arr = items[i].split('=');
        if (name === arr[0].trim()) {
          return arr[1].trim();
        }
      }
      return '';
    },
    clear: function clear() {
      var domain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.iqiyi.com';
      var cookies = document.cookie.split(';');
      if (cookies.length > 0) {
        for (var i = 0; i < cookies.length; i = i + 1) {
          var cookie = cookies[i];
          var eqPos = cookie.indexOf('=');
          var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
          document.cookie = "".concat(name, "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; Domain=").concat(domain, "; path=/");
        }
      }
    }
  };
  return cookie;
}));
});

var NATIVE_COOKIE = 'P00001';
var info = {
  iqyData: null,
  getAuthCookie: function () {
    var _getAuthCookie = asyncToGenerator(
    regenerator.mark(function _callee() {
      var o;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(typeof window === 'undefined')) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", '');
            case 2:
              if (!(detector.iqiyi() || detector.zhishi())) {
                _context.next = 12;
                break;
              }
              if (!this.iqyData) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return", this.iqyData[NATIVE_COOKIE] || '');
            case 5:
              _context.next = 7;
              return iqiyi_1.init();
            case 7:
              o = _context.sent;
              if (o) {
                _context.next = 10;
                break;
              }
              return _context.abrupt("return", '');
            case 10:
              this.iqyData = o;
              return _context.abrupt("return", this.iqyData[NATIVE_COOKIE] || '');
            case 12:
              return _context.abrupt("return", cookie.get(NATIVE_COOKIE, document.cookie));
            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
    function getAuthCookie() {
      return _getAuthCookie.apply(this, arguments);
    }
    return getAuthCookie;
  }(),
  clear: function clear() {
    this.iqyData = null;
    cookie.clear();
  }
};

var index = {
  login: function () {
    var _login = asyncToGenerator(
    regenerator.mark(function _callee(redirect) {
      var opt;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              if (!(detector.zhishi() || detector.iqiyi())) {
                _context.next = 12;
                break;
              }
              _context.next = 4;
              return iqiyi_1.ready();
            case 4:
              if (!(detector.iOS() && (detector.iqiyi() && iqiyi_1.getVersion() >= 110400 || detector.zhishi() && iqiyi_1.getVersion() >= 20300))) {
                _context.next = 9;
                break;
              }
              opt = {
                page: 'login',
                isHalfScreenLoginModule: '1'
              };
              if (redirect) {
                opt.returnUrl = redirect;
              }
              iqiyi.loadNativePage(opt);
              return _context.abrupt("return");
            case 9:
              if (redirect) {
                iqiyi.login(redirect);
              } else {
                iqiyi.login();
              }
              _context.next = 14;
              break;
            case 12:
              info.clear();
              location.href = "//m.iqiyi.com/user.html?isHideNav=1&onestepoff=1&from=zhishi01&redirect_url=".concat(encodeURIComponent(redirect || location.href), "#baseLogin");
            case 14:
              _context.next = 19;
              break;
            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](0);
              throw new Error(_context.t0.message);
            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 16]]);
    }));
    function login(_x) {
      return _login.apply(this, arguments);
    }
    return login;
  }(),
  isLogin: function () {
    var _isLogin = asyncToGenerator(
    regenerator.mark(function _callee2() {
      var authCookie;
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return info.getAuthCookie();
            case 2:
              authCookie = _context2.sent;
              return _context2.abrupt("return", !!authCookie);
            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    function isLogin() {
      return _isLogin.apply(this, arguments);
    }
    return isLogin;
  }(),
  getAuthCookie: function () {
    var _getAuthCookie = asyncToGenerator(
    regenerator.mark(function _callee3() {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return info.getAuthCookie();
            case 3:
              return _context3.abrupt("return", _context3.sent);
            case 6:
              _context3.prev = 6;
              _context3.t0 = _context3["catch"](0);
              return _context3.abrupt("return", '');
            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 6]]);
    }));
    function getAuthCookie() {
      return _getAuthCookie.apply(this, arguments);
    }
    return getAuthCookie;
  }()
};

export default index;
